import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback, useMemo } from 'react';
import { PreOrderInterval, preparationPreOrderIntervalOptions, preparationPreOrderPeriodUnitOptions } from '../../constants/preparationProfiles';
import { preparationPreOrderPeriodMessage } from '../../helpers/preparationProfilesHelpers';
import preparationProfilesStore from '../../store/preparationProfilesStore';
import { PreparationOrderSettingsInput } from '../PreparationOrderSettingsInput/PreparationOrderSettingsInput';
import { PreparationOrderSettingsRadios } from '../PreparationOrderSettingsRadios/PreparationOrderSettingsRadios';
import Text, { TEXT } from '~/view/components/Text/Text';
import TabPicker from '~/view/components/Controls/Pickers/TabPicker/TabPicker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

export const PreparationPreOrderSettings: FC = observer((): ReactElement | null => {
  const preOrderPeriodUnitOptions = useMemo((): IPickerOption[] => preparationPreOrderPeriodUnitOptions(), []);
  const preOrderIntervalOptions = useMemo((): IPickerOption[] => preparationPreOrderIntervalOptions(), []);

  const preOrderPeriodMessage = useMemo((): string | null => {
    return preparationPreOrderPeriodMessage();
  }, [preparationProfilesStore.selectedProfile.preOrderPeriodUnit]);

  const changePreOrderInterval = useCallback((value: PreOrderInterval) => {
    preparationProfilesStore.changeSelectedProfile({ preOrderInterval: value });
  }, []);

  const { preOrderInterval } = preparationProfilesStore.selectedProfile;
  const { preOrderPeriod } = preparationProfilesStore.validation;

  return (
    <div className="d-flex flex-column gap-20">
      <Text text="pre_order_settings" type={TEXT.SECTION_HEADER} />

      <div className="d-flex flex-column gap-25">
        <PreparationOrderSettingsRadios title="pre_order_units" options={preOrderPeriodUnitOptions} field="preOrderPeriodUnit" />

        {preOrderPeriodMessage ? (
          <div className="d-flex flex-column gap-10">
            <PreparationOrderSettingsInput title="pre_order_latest_date" field="preOrderPeriod" />
            <Text text={preOrderPeriodMessage} type="recommendation" error={!preOrderPeriod.isValid} className="mt-0" />
          </div>
        ) : null}

        <div className="d-flex flex-column gap-10">
          <Text text="pre_order_interval" type={TEXT.BLOCK_HEADER} />
          <TabPicker value={preOrderInterval} options={preOrderIntervalOptions} onChange={changePreOrderInterval} className="width-fit" />
        </div>
      </div>
    </div>
  );
});
